import { inject } from '@angular/core';
import { HomeS } from './home';
import { Core } from './core';
import { IHome } from '../core.interface';

export async function ensureHomeData(): Promise<IHome | null> {
  const $home = inject(HomeS);
  const $core = inject(Core);

  await $core.ensureLoaded();

  if (!$core.selectedBuilding()) {
    return null;
  }

  const cached = $home.homeData();
  if (cached) {
    return cached;
  }

  return (await $home.fetchHomeData()) ?? null;
}
